import { DatePicker } from '../DatePicker'
import { BasicFormItem, BasicFormItemProps } from './BasicFormItem'

interface FormDateProps extends BasicFormItemProps {
  max?: string
}

export const FormDate = (props: Omit<FormDateProps, 'component'>) => (
  <BasicFormItem component={DatePicker} {...props} />
)
